import React from "react";
import axiosInstance from "../../services/axios";
import { ActionTypes } from "../action-type";
import { UseSelector, useSelector } from "react-redux/es/hooks/useSelector";
import { general_notification } from "../../utils/notification";
import { useNavigate } from "react-router-dom";

export const joiningDebate = (values,navigate) => async(dispatch)=>{
    // const navigate = useNavigate()
    try{
        const url = values.type === "audience" ? `/join/audience/${values.code}` : "/join/member"
        const response = values.type === "audience" ? await axiosInstance.get(url) :await axiosInstance.post(url,values);
        const {data} = response;
        dispatch({
            type:ActionTypes.JOINING_DEBATE,
            payload:data
        })

    }
    
    catch(err){
        navigate("/login")
        // general_notification("Please login before joining as participant")

    }
}